export const TRANSLATION_KEYS = {
    AttachmentLabel: "ticketDetailsPage.detailsForm.attachmentLabel",
    DeleteText: "common.deleteText",
    OpenText: "common.openText"
};